export const LAZY_LOADING_TYPE_BUTTON = 'LAZY_BUTTON';
export const LAZY_LOADING_TYPE_SCROLL = 'LAZY_SCROLL';

export const URL_COMPLAINTS_API_REPORT = '/complaints/report';
export const URL_COMPLAINTS_API_REPORT_NEW = '/complaints/report/new';
export const URL_COMPLAINTS_API_REPORTS = '/complaints/api/reports';
export const URL_SOCIAL_BAR = '/pages/social/shares';
